import React, { useState, useEffect } from 'react';
import { getDatabase, ref, onValue } from 'firebase/database';
import { Modal, Button } from 'react-bootstrap';
import './AuditLogs.css';

export default function DoctorAssignmentLogs({ show, onHide }) {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (show) {
      const db = getDatabase();
      const assignmentLogsRef = ref(db, 'audit_logs/UserManagement/Doctor_Assignment_Admin');
      const bulkAssignmentLogsRef = ref(db, 'audit_logs/UserManagement/Bulk_Assignment_Admin');
      
      // Get individual assignments
      const unsubscribeAssignment = onValue(assignmentLogsRef, (snapshot) => {
        const data = snapshot.val() || {};
        const adminName = localStorage.getItem('adminName');
        const assignmentLogs = Object.entries(data)
          .filter(([_, entry]) => entry.assigned_by === adminName)
          .map(([id, entry]) => ({
            id,
            type: 'individual',
            ...entry
          }));
        
        // Get bulk assignments
        const unsubscribeBulk = onValue(bulkAssignmentLogsRef, (bulkSnapshot) => {
          const bulkData = bulkSnapshot.val() || {};
          const bulkLogs = Object.entries(bulkData)
            .filter(([_, entry]) => entry.assigned_by === adminName)
            .map(([id, entry]) => ({
              id,
              type: 'bulk',
              ...entry
            }));

          // Combine and sort all logs by timestamp
          const allLogs = [...assignmentLogs, ...bulkLogs].sort((a, b) => 
            new Date(b.timestamp) - new Date(a.timestamp)
          );
          
          setLogs(allLogs);
          setLoading(false);
        });

        return () => {
          unsubscribeBulk();
        };
      });

      return () => {
        unsubscribeAssignment();
      };
    }
  }, [show]);

  const formatDate = (timestamp) => {
    return new Date(timestamp).toLocaleString();
  };

  return (
    <Modal show={show} onHide={onHide} size="xl">
      <Modal.Header closeButton>
        <Modal.Title>Doctor Assignment Audit Logs</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {loading ? (
          <div className="text-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        ) : (
          <div className="table-responsive">
            <table className="table table-striped table-bordered">
              <thead className="table-light">
                <tr>
                  <th>Timestamp</th>
                  <th>Event Type</th>
                  <th>Assigned Doctor</th>
                  <th>Patient Info</th>
                  <th>Status</th>
                  <th>Device Info</th>
                  <th>Location</th>
                </tr>
              </thead>
              <tbody>
                {logs.map((log) => (
                  <tr key={log.id}>
                    <td>{formatDate(log.timestamp)}</td>
                    <td>
                      {log.type === 'bulk' ? 'Bulk Assignment' : 
                       log.event_type === 'doctor_unassigned_admin' ? 'Doctor Unassigned' : 
                       'Individual Assignment'}
                    </td>
                    <td>{log.assigned_doctor}</td>
                    <td>
                      {log.type === 'bulk' ? 
                        `${log.patient_count} patients` :
                        log.patient_name
                      }
                    </td>
                    <td>
                      <span className={`badge ${log.success ? 'bg-success' : 'bg-danger'}`}>
                        {log.success ? 'Success' : 'Failed'}
                      </span>
                      {!log.success && log.failure_reason && (
                        <div className="small text-danger mt-1">
                          {log.failure_reason}
                        </div>
                      )}
                    </td>
                    <td>
                      {log.details?.device}<br/>
                      <small className="text-muted">{log.details?.browser}</small>
                    </td>
                    <td>
                      {log.details?.location}<br/>
                      <small className="text-muted">IP: {log.details?.ip}</small>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Close
        </Button>
      </Modal.Footer>
    </Modal>
  );
} 